import { Component } from "react";
import { Outlet, useLocation } from "react-router-dom";
import V2Sidebar from "./V2Sidebar";
import { useV2Auth } from "../V2App";
import "./V2Layout.css";

class V2ErrorBoundary extends Component {
	constructor(props) {
		super(props);
		this.state = { error: null };
	}
	static getDerivedStateFromError(error) {
		return { error };
	}
	render() {
		if (this.state.error) {
			return (
				<div style={{ padding: 40, maxWidth: 480 }}>
					<div
						style={{
							padding: 20,
							background: "rgba(139,58,58,0.08)",
							color: "#8B3A3A",
							border: "1px solid #8B3A3A",
							borderRadius: 8,
						}}
					>
						<div style={{ fontWeight: 600, fontSize: 16, marginBottom: 8 }}>
							Something went wrong
						</div>
						<div style={{ fontSize: 13, marginBottom: 16 }}>
							{this.state.error?.message || "Unexpected error"}
						</div>
						<button
							onClick={() => {
								this.setState({ error: null });
								window.location.href = "/workspace";
							}}
							style={{
								padding: "8px 16px",
								background: "#23201C",
								color: "#F3F2ED",
								border: "none",
								borderRadius: 4,
								cursor: "pointer",
								fontSize: 13,
							}}
						>
							Return to Workspace
						</button>
					</div>
				</div>
			);
		}
		return this.props.children;
	}
}

const breadcrumbMap = {
	"/dashboard": "Dashboard",
	"/workspace": "Workspace",
	"/chat": "Quote Assistant",
	"/shipments": "Shipments",
	"/shipments/new": "Shipments / New Shipment",
	"/providers": "Providers",
	"/settings": "Settings",
	"/billing": "Billing",
};

export default function V2Layout() {
	const { user } = useV2Auth();
	const location = useLocation();

	const getBreadcrumb = () => {
		const exact = breadcrumbMap[location.pathname];
		if (exact) return exact;

		if (location.pathname.startsWith("/workspace/")) {
			return "Workspace / Shipment";
		}
		if (
			location.pathname.includes("/shipments/") &&
			location.pathname.includes("/compare")
		) {
			return "Shipments / Quote Comparison";
		}
		if (location.pathname.includes("/shipments/")) {
			return "Shipments / Details";
		}
		return "Dashboard";
	};

	return (
		<div className="v2-layout">
			<V2Sidebar />
			<div className="v2-main">
				<header className="v2-topbar">
					<span className="v2-breadcrumb">{getBreadcrumb()}</span>
					<div className="v2-topbar-right">
						<div className="v2-topbar-avatar">
							{user?.avatarInitials || "U"}
						</div>
					</div>
				</header>
				<main className="v2-content">
					<V2ErrorBoundary>
						<Outlet />
					</V2ErrorBoundary>
				</main>
			</div>
		</div>
	);
}
